// extracted by mini-css-extract-plugin
module.exports = {"container":"security_container__2PbNz","form":"security_form__g2_sf","errors":"security_errors__1EtOV","logo":"security_logo__MmRd_"};